<template>
  <div>
    <Head title="Create Project" />
    <h1 class="mb-8 text-3xl font-bold">
      Master
      <span class="text-indigo-400 font-medium"> / </span>
      <Link class="text-indigo-400 hover:text-indigo-600" href="/projects">
        Projects
      </Link>
      <span class="text-indigo-400 font-medium"> / </span>Create
    </h1>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="store">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <select-input
            v-model="form.ref_area_project_id"
            :error="form.errors.ref_area_project_id"
            class="pb-8 pr-6 w-full lg:w-1/2"
            label="Area Project">
            <option
              v-for="areaproject in areaprojects"
              :key="areaproject.id"
              :value="areaproject.id">
              {{ areaproject.code + ' - ' + areaproject.location }}
            </option>
          </select-input>
          <text-input
            v-model="form.code"
            :error="form.errors.code"
            class="pb-8 pr-6 w-full lg:w-1/2"
            label="Code" />
          <text-input
            v-model="form.p_year_start"
            :error="form.errors.p_year_start"
            class="pb-8 pr-6 w-1/2 lg:w-1/4"
            type="number"
            label="Year Start" />
          <select-input
            v-model="form.p_month_start"
            :error="form.errors.p_month_start"
            class="pb-8 pr-6 w-1/2 lg:w-1/4"
            label="Month Start">
            <option
              v-for="month in months"
              :key="month.code"
              :value="month.code">
              {{ month.text }}
            </option>
          </select-input>
          <text-input
            v-model="form.p_year_end"
            :error="form.errors.p_year_end"
            class="pb-8 pr-6 w-1/2 lg:w-1/4"
            type="number"
            label="Year End" />
          <select-input
            v-model="form.p_month_end"
            :error="form.errors.p_month_end"
            class="pb-8 pr-6 w-1/2 lg:w-1/4"
            label="Month End">
            <option
              v-for="month in months"
              :key="month.code"
              :value="month.code">
              {{ month.text }}
            </option>
          </select-input>
          <textarea-input
            v-model="form.title"
            :error="form.errors.title"
            rows="6"
            class="pb-8 pr-6 w-full lg:w-1/2"
            label="Title" />
          <textarea-input
            v-model="form.description"
            :error="form.errors.description"
            rows="6"
            class="pb-8 pr-6 w-full lg:w-1/2"
            label="Description" />
          <select-input
            v-model="form.organization_id"
            :error="form.errors.organization_id"
            class="pb-8 pr-6 w-full lg:w-1/2"
            label="Donor">
            <option
              v-for="organization in organizations"
              :key="organization.id"
              :value="organization.id">
              {{ organization.code }}
            </option>
          </select-input>
          <text-input
            v-model="form.concern"
            :error="form.errors.concern"
            class="pb-8 pr-6 w-full lg:w-1/2"
            label="Concern" />
        </div>
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button
            :loading="form.processing"
            class="btn-indigo"
            type="submit">
            Create Project
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TextareaInput from '@/Shared/TextareaInput'

export default {
    components: {
        Head,
        Link,
        LoadingButton,
        SelectInput,
        TextInput,
        TextareaInput,
    },
    layout: Layout,
    props: {
        areaprojects: Object,
        organizations: Object,
    },
    remember: 'form',
    data () {
        return {
            form: this.$inertia.form({
                ref_area_project_id: null,
                code: null,
                p_year_start: null,
                p_month_start: null,
                p_year_end: null,
                p_month_end: null,
                title: null,
                description: null,
                organization_id: null,
                concern: null,
            }),
            months: [
                { code: 1, text: 'JAN' },
                { code: 2, text: 'FEB' },
                { code: 3, text: 'MAR' },
                { code: 4, text: 'APR' },
                { code: 5, text: 'MAY' },
                { code: 6, text: 'JUN' },
                { code: 7, text: 'JUL' },
                { code: 8, text: 'AUG' },
                { code: 9, text: 'SEP' },
                { code: 10, text: 'OCT' },
                { code: 11, text: 'NOV' },
                { code: 12, text: 'DEC' },
            ],
        }
    },
    methods: {
        store () {
            this.form.post('/projects')
        },
    },
}
</script>
